export const px2vw = (size: number, width = 1440) =>
  `${(size / width) * 100}vw`;

export const exportFile = async (blob: Blob, fileName: string) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.setAttribute('download', fileName);

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  window.URL.revokeObjectURL(objectUrl);
};

// Browser detection utilities
export * from './browser-detection';

// Audio utilities
export * from './audio-utils';

// Mobile audio utilities
export * from './mobile-audio-utils';

// WebAudio SFX utilities
export * from './web-audio';

// Flag utilities
export * from './flag-utils';

// File/URL detection utilities
export const isUrl = (value: string | File | null | undefined): boolean => {
  if (!value || typeof value !== 'string') return false;
  
  // Проверяем, является ли строка URL
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

export const isFile = (value: string | File | null | undefined): boolean => {
  return value instanceof File;
};

export const getContentType = (value: string | File | null | undefined): 'file' | 'url' | 'empty' => {
  if (!value) return 'empty';
  if (isFile(value)) return 'file';
  if (isUrl(value)) return 'url';
  return 'empty';
};
